export const useAccountStore = defineStore('account', {
  state: () => ({
    notification: {},
    routinesSlider: {
      heading: null,
      routines: [],
      active: true,
    },
    productsSlider: {
      heading: null,
      products: [],
      active: true,
    },
    maintenance: {
      message: null,
      active: false,
    },
    loginDisabled: false,
  }),

  getters: {
    getNotification: (state) => state.notification,
    getRoutinesSlider: (state) => state.routinesSlider,
    getProductsSlider: (state) => state.productsSlider,
  },

  actions: {
    init(account, { loginDisabled = false } = {}) {
      this.loginDisabled = loginDisabled;

      this.notification = {
        heading: account.heading,
        active: account.onOffSwitch,
        description: account.description,
      };
      this.routinesSlider = {
        routines: account.routines,
        active: account.recommendedOn,
        heading: account.routinesSliderHeading,
      };
      this.productsSlider = {
        products: account.products,
        active: account.bestsellersOn,
        heading: account.productsSliderHeading,
      };
      this.maintenance = {
        message: account.maintenanceMessage,
        active: account.isAuthDisabled ?? false,
      };
    },
  },
});
